var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"nextPage",staticClass:"next-page-wrap",class:{ loading: _vm.loading }},[(_vm.open && !_vm.loading)?_c('button',{on:{"click":_vm.next}},[_vm._v("下一页")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }